import React from "react";
import Container from "@/components/marketing/Container";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import HeroBackground from "@/components/marketing/HeroBackground";
import { useAuth } from "@/lib/AuthContext";

const STATS = [
  { value: "Khaleej Times to Gulf News", label: "Named UAE titles" },
  { value: "From $475", label: "Gulf newswire syndication" },
  { value: "Arabic + English", label: "Bilingual distribution" },
  { value: "Same-day", label: "Submission" },
];

export default function UaeHero() {
  const { isAuthenticated } = useAuth();
  const primaryTo = isAuthenticated ? "/dashboard/new-order" : "/register";

  return (
    <section className="relative pt-24 lg:pt-28 pb-7 sm:pb-9 lg:pb-12 overflow-hidden text-center">
      <HeroBackground />
      <Container className="relative">
        <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#6d28d9] mb-4">
          UAE PR Distribution
        </div>
        <h1 className="font-heading text-[clamp(36px,5vw,56px)] font-[650] tracking-[-0.03em] leading-[1.06] mb-5 max-w-3xl mx-auto text-heading-gradient">
          Press release distribution in the UAE.
        </h1>
        <p className="text-[16px] lg:text-[17px] leading-[1.55] text-[#6c6c74] max-w-[560px] mx-auto mb-8">
          Reach the UAE's leading English and Arabic media. Guaranteed placements in named UAE titles, Gulf newswire syndication, and direct journalist outreach, all from one self serve platform with pricing shown upfront.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to={primaryTo}
            className="inline-block text-[14px] font-semibold px-6 py-[13px] rounded-[14px] bg-brand-gradient text-white whitespace-nowrap transition-opacity hover:opacity-90"
            style={{ boxShadow: "0 8px 20px rgba(124,58,237,0.35)" }}>
            Get Started <ArrowRight className="inline w-4 h-4 ml-1" />
          </Link>
          <Link to="/contact"
            className="inline-block text-[14px] font-semibold px-6 py-[13px] rounded-[14px] bg-dark-pill text-white whitespace-nowrap transition-colors hover:bg-[#3c3c42]">
            Talk to Our Team
          </Link>
        </div>
        <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-6 lg:gap-8 max-w-3xl mx-auto">
          {STATS.map((stat) => (
            <div key={stat.label}>
              <div className="font-heading text-xl lg:text-2xl font-[650] text-[#1c1c20] leading-tight">{stat.value}</div>
              <div className="text-xs text-[#8e8e96] mt-1 leading-tight">{stat.label}</div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}